module.exports = __webpack_public_path__ + "img/CRC2_Mast.36868795.png";